import ServiceObjectMaintenanceNotesFastFix from './ServiceObjectMaintenanceNotesFastFix.vue'
import { ACTIONS } from './ServiceObjectMaintenanceNote.js'

export const fastFixServiceObjectMaintenanceNotes = {
  components: {
    ServiceObjectMaintenanceNotesFastFix
  },
  computed: {
    serviceObjectMaintenanceNotesTableSourceProps: function () {
      const serviceObject = this.serviceObject || this.request && this.request.serviceObject || { id: this.request.objectId, name: this.request.object, type: { key: this.request.objectType } }
      return { recordSource: 'requestReport', serviceObjectId: serviceObject.id, serviceObjectName: serviceObject.name, serviceObjectType: serviceObject.type.key, requestReportId: this.report.id, id: this.report.id }
    }
  },
  methods: {
    fastFixServiceObjectMaintenanceNotes: function (notes, callback) {
      const dialog = this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: ServiceObjectMaintenanceNotesFastFix,
        contentProps: {
          notes: notes,
          action: ACTIONS.find(action => action.key === 'fix'),
          sourceProps: this.serviceObjectMaintenanceNotesTableSourceProps
        },
        componentHandlers: {
          cancel: () => {
            dialog.hide()
          },
          done: () => {
            dialog.hide()
            callback()
          }
        }
      })
    }
  }
}
